import { Form } from 'formik'
import styled from 'styled-components'

import { BlueGradientButton, StyledButton } from 'components'
import { COLOR } from 'styles/constants'

export const PrimaryButton = styled(BlueGradientButton)``

export const SecondaryButton = styled(StyledButton)`
  border: 1px solid ${COLOR.GREY_UNDEFINED};
  background-color: ${COLOR.WHITE};
`

export const PrescreenStyled = styled(Form)`
  margin: 0;
  padding: 0;

  display: flex;
  flex-flow: row wrap;
  flex-direction: row-reverse;
  gap: 16px 24px;

  & > div {
    width: 100%;
    margin: 0;

    &:last-child {
      margin-bottom: 8px;
    }
  }

  ${PrimaryButton}, ${SecondaryButton} {
    flex: 1 1 auto;
    margin: 8px 0 0;
    width: calc(50% - 12px);
  }

  @media (max-width: 991px) {
    width: 100%;
    padding: 0;

    ${PrimaryButton}, ${SecondaryButton} {
      margin: 0;
      width: 100%;
    }

    ${PrimaryButton} {
      margin-top: 8px;
    }
  }
`
